import * as React from "react";
import { useEffect, useReducer, useRef, useState } from 'react';
import { Spinner, Button } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import * as Models from '../models';
import { MediaService, SearchIn } from '../services/MediaService';
import classnames from 'classnames';
import { connect } from 'react-redux';
import EmptySpace from './EmptySpace';

const PAGE_SIZE = 10;

type Props = {
    path: string;
    active: boolean;
    culture: string;
}
type SiteSearchPageState = {
    keywords: string;
    canLoadMore: boolean;
    isLoading: boolean;
    isNoResults: boolean;
    items: Models.Media[];
    totalItems: number;
    lastFilter: SearchIn
    searchTrigger: number;
}

const initialState: SiteSearchPageState = {
    keywords: '',
    canLoadMore: false,
    isLoading: false,
    isNoResults: false,
    items: [],
    totalItems: 0,
    lastFilter: undefined,
    searchTrigger: 0,
}

const getUrlVars = (paramName) => {

    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
}


const MediaListing = (props: Props) => {

    const [state, setState] = useReducer(
        (prevState: SiteSearchPageState, newState: Partial<SiteSearchPageState>) => ({ ...prevState, ...newState }),
        initialState
    );

    const search = async () => {

        //window.history.pushState({}, '', '?q=' + state.keywords);
        const lastFilter: SearchIn = {
            keywords: state.keywords,
            path: props.path,
            culture: props.culture
        };

        setState({
            isLoading: true,
            lastFilter: lastFilter,
            //items: [],
            //lastSearchBy: state.searchBy
        });

        const result = await MediaService.search(lastFilter, PAGE_SIZE, 0);

        if (!result.hasErrors) {
            setState({
                items: result.value.items,
                totalItems: result.value.totalItems,
                isLoading: false,
                isNoResults: result.value.totalItems == 0,
                canLoadMore: result.value.totalItems > result.value.items.length,
            })
        }
    }

    const loadMore = async () => {

        setState({
            isLoading: true
        });

        const result = await MediaService.search(state.lastFilter, PAGE_SIZE, state.items.length);

        if (!result.hasErrors) {

            const newItemsSet = state.items.concat(result.value.items);

            setState({
                items: newItemsSet,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > newItemsSet.length
            })
        }
    }

    useEffect(() => {

        if (props.active)
            search();

    }, [props.active]);

    return (
        <>
            {/*<div className="container mb-3">
                <div className="row align-items-end listing-filters">
                    <div className="col-lg-6 col-md-6 col-sm-12 pe-0 mb-3">
                        <div className="form-group">
                            <label>Search</label>
                            <input type="text" onChange={(e) => { setState({ keywords: e.target.value }) }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        search();
                                    }
                                }}
                                placeholder="Keywords Search" className="form-control" /></div>
                    </div>
                    <div className="col-auto col-xs-12 mb-3 pe-0">
                        <div className="form-group mt-lg-3" ><button type="button" className="btn btn-primary d-block w-100" onClick={search}>Search</button></div>
                    </div>
                </div>
            </div>
            */}
            <div className="bg-white pb-1 pt-3 news-section">
                <div className="container">

                    {state.isNoResults &&
                        <div className="row" >
                            <div className="col">
                                <h3>No Results</h3>
                                <EmptySpace extraOffset={45} />
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col">
                            <table className="table">
                                <InfiniteScroll
                                    pageStart={0}
                                    loadMore={loadMore}
                                    hasMore={state.canLoadMore && !state.isLoading && state.lastFilter && props.active}
                                    useWindow={true}
                                    element="tbody"
                                >
                                    {state.items.map(item => {
                                        return <tr>
                                            <td>
                                                <div className="small-title">{item.publication}</div>
                                                <a key={item.nodeId} href={item.url} target={item.urlTarget}>
                                                    <h5 className="title" dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                                                </a>
                                            </td>                                            
                                            <td className="text-nowrap date-cell">
                                                <div>{item.date}</div>
                                            </td>
                                        </tr>
                                    })}
                                </InfiniteScroll>
                            </table>

                            <div className="text-center" style={{
                                marginTop: "-12px",
                                height: "45px"
                            }}>
                                {state.isLoading &&
                                    <Spinner color="primary" />
                                }
                            </div>
                            {state.lastFilter && state.lastFilter.keywords.length == 0 && !state.isNoResults &&
                                <EmptySpace extraOffset={45} />
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default MediaListing;
